jQuery(document).foundation();

jQuery(document).ready(function () {
  let subscriptionDataFromPosition = (position) =>
    basicSubscriptionsData.find((k) => k.position === position);

  let subscriptionPrice = (data, checked) =>
    checked ? data.price + data.priceAutoDJ : data.price;

  var selectedSubscriptionData;

  jQuery(".switch-input").on("click", function () {
    const subscriptionContainer = jQuery(this).parents(".js-subscription");

    const data = subscriptionDataFromPosition(
      subscriptionContainer.data("subscription-position") // position is 1, 2 or 3
    );

    const price = subscriptionPrice(
      data,
      this.checked // Auto-DJ switch checked?
    );

    const priceElement = subscriptionContainer.find(".js-price"); // Only the price, without the currency sign

    priceElement.fadeTo("fast", 0).text(price).fadeTo("fast", 1);
  });

  function selectBasicSubscription(e) {
    e.preventDefault();

    const selectButton = e.target;

    const subscriptionContainer = selectButton.closest(".js-subscription");
    const position = subscriptionContainer.dataset.subscriptionPosition; // 1, 2 or 3);
    const slots = subscriptionContainer.dataset.basicSubscriptionSlots; // 25, 50, 100

    const autoDJChecked = subscriptionContainer.querySelector(".switch-input")
      .checked
      ? "on"
      : "off";

    const data = {
      position: position,
      subscription: {
        slots: slots,
        auto_dj: autoDJChecked,
      },
    };

    let modal = jQuery("#type-select-modal");

    jQuery
      .ajax({
        url: jQuery(this).attr("href"),
        data: data,
      })
      .done(function (response) {
        modal.html(response).foundation("open");
      });
  }

  jQuery(".js-select-abo-button").on("click", selectBasicSubscription);

  let bodyElement = document.querySelector(".js-body");
  let navToggle = document.querySelector(".js-nav-toggle");
  let nav = document.querySelector(".js-nav");

  let touchStartX = 0;
  let touchEndX = 0;

  const toggleBody = () =>
    bodyElement.classList.toggle("header-navigation-menu-open");

  nav.addEventListener(
    "touchstart",
    (e) => {
      touchStartX = e.changedTouches[0].screenX;
    },
    true
  );

  nav.addEventListener("touchend", (e) => {
    touchEndX = e.changedTouches[0].screenX;
    if (touchEndX < touchStartX) {
      navToggle.checked = false;
      toggleBody();
    }
  });

  navToggle.addEventListener("change", toggleBody);
});
